import * as React from 'react';
import { Scroller } from '@cian/slider';

import { OnboardingSlideDesktop } from '../../../../components/OnboardingSlideDesktop';
import { OnboardingSlideMobile } from '../../../../components/OnboardingSlideMobile';
import { TOnboardingSlide } from '../index';

type TProps = {
  slides: TOnboardingSlide[];
  isMobile?: boolean;
};

export const OnboardingSlidesContainer: React.FC<TProps> = ({ slides, isMobile }) => {
  const slideNodes = React.useMemo(() => {
    return slides.map(({ title, text, src }) =>
      isMobile ? (
        <OnboardingSlideMobile key={title} src={src} title={title} text={text} />
      ) : (
        <OnboardingSlideDesktop key={title} src={src} title={title} text={text} />
      ),
    );
  }, [isMobile, slides]);

  return <Scroller>{slideNodes}</Scroller>;
};
